module.exports = __webpack_public_path__ + "img/03.049e4d40.jpg";